var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagePart',{attrs:{"setTitle":_vm.setTitle,"setBreadcrumbs":_vm.setBreadcrumbs},scopedSlots:_vm._u([{key:"default",fn:function({
        title,
        backLink
      }){return [_vm._t("default",null,{"title":title,"backLink":backLink})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }